module.exports = __webpack_public_path__ + "static/media/19ESCAP49.ec3c9461.jpg";